<div class="fundo" role="dialog" aria-modal="true" aria-label="Transferir / remarcar">
  <div class="modal">
    <div class="modal-cab">
      <div class="cab-ico" aria-hidden="true"><svg class="i" viewBox="0 0 24 24"><path d="M7 7h13l-4-4M17 17H4l4 4" /></svg></div>
      <div class="cab-txt">
        <b>Transferir / remarcar{{ lote ? ' · ' + origens.length + ' pacientes' : '' }}</b>
        <span>{{ subtitulo }}</span>
      </div>
      <button type="button" class="btn-ico fechar-modal" title="Fechar (Esc)" (click)="cancelar()" [disabled]="salvando">
        <svg class="i" viewBox="0 0 24 24"><path d="M6 6l12 12M18 6 6 18" /></svg>
      </button>
    </div>

    <div class="modal-corpo">
      <div class="alerta bad" *ngIf="erroAbertura" role="alert">
        <svg class="i sm" viewBox="0 0 24 24"><path d="M12 3 2 21h20z" /><path d="M12 10v5M12 18h.01" /></svg>
        <div>{{ erroAbertura }}</div>
      </div>

      <div class="alerta warn" *ngIf="ignorados.length">
        <svg class="i sm" viewBox="0 0 24 24"><path d="M12 3 2 21h20z" /><path d="M12 10v5M12 18h.01" /></svg>
        <div>
          <b>{{ ignorados.length }} {{ ignorados.length > 1 ? 'ficam' : 'fica' }} de fora:</b>
          <span *ngFor="let i of ignorados; let ult = last">
            {{ i.linha.hrInicio }} {{ i.linha.paciente.nmPaciente || 'Horário livre' }} ({{ i.motivo }}){{ ult ? '.' : ';' }}
          </span>
        </div>
      </div>

      <ng-container *ngIf="!erroAbertura && origem as o">
        <!-- Origem -->
        <div class="origem" *ngIf="!lote">
          <div>
            <span class="sub2">Origem</span>
            <b>{{ o.paciente.nmPaciente }}</b>
            <span class="sub2">
              {{ rotuloDia(o.dtAgenda) }} · {{ o.hrInicio }} · {{ o.dsAgenda }} · {{ ehExame ? o.dsExame : o.especialidade.dsEspecialidade }}
            </span>
          </div>
          <span class="seta"><svg class="i" viewBox="0 0 24 24"><path d="M5 12h14M13 6l6 6-6 6" /></svg></span>
          <div *ngIf="destino as d; else semDestino">
            <span class="sub2">Destino</span>
            <b>{{ rotuloDia(d.dtDisponivel || '') }} · {{ d.hrInicio }}</b>
            <span class="sub2">{{ d.dsAgenda }} · {{ d.nmEstabelecimento }}</span>
          </div>
          <ng-template #semDestino><span class="sub2">Escolha um horário abaixo</span></ng-template>
        </div>

        <div *ngIf="lote">
          <span class="rot">Pacientes a transferir ({{ origens.length }})</span>
          <div class="mini-wrap">
            <table class="mini">
              <thead>
                <tr><th>Hora</th><th>Paciente</th><th>Classif.</th><th>Médico</th><th></th></tr>
              </thead>
              <tbody>
                <tr *ngFor="let x of origens; trackBy: trackOrigem" [class.travou]="x === bloqueado">
                  <td><b>{{ x.hrInicio }}</b><span class="sub2" *ngIf="x.dtAgenda.slice(0, 10) !== o.dtAgenda.slice(0, 10)"> {{ dataCurta(x.dtAgenda) }}</span></td>
                  <td>
                    {{ x.paciente.nmPaciente }}
                    <span class="selo bad" *ngIf="x === bloqueado">travou o lote</span>
                  </td>
                  <td>{{ x.dsClassifAgenda }}</td>
                  <td>{{ medicoAtual(x) }}</td>
                  <td class="acao">
                    <button
                      type="button"
                      class="link"
                      title="Tirar do lote"
                      [disabled]="salvando || origens.length === 1"
                      (click)="removerOrigem(x)"
                    >tirar</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <p class="dica">Os pacientes entram nos primeiros horários livres da agenda escolhida, na ordem da lista. O canal de contato é herdado da origem.</p>
        </div>

        <!-- Filtros -->
        <div class="grid3" *ngIf="!ehExame">
          <div class="campo">
            <label for="tUn">Unidade</label>
            <select id="tUn" [ngModel]="cdEstabelecimento" (ngModelChange)="trocarEstabelecimento($event)" [disabled]="buscando || salvando">
              <option [ngValue]="null">Todas as unidades</option>
              <option *ngFor="let e of estabelecimentos" [ngValue]="e.cdEstabelecimento">{{ e.nmEstabelecimento || e.sigla || e.cdEstabelecimento }}</option>
            </select>
          </div>
          <div class="campo">
            <label for="tEsp">Especialidade</label>
            <select id="tEsp" [ngModel]="cdEspecialidade" (ngModelChange)="trocarEspecialidade($event)" [disabled]="buscando || salvando">
              <option [ngValue]="null">Todas</option>
              <option *ngFor="let e of especialidades" [ngValue]="e.codigo">{{ e.descricao }}</option>
            </select>
          </div>
          <div class="campo">
            <label for="tMed">Médico</label>
            <select id="tMed" [ngModel]="cdMedico" (ngModelChange)="trocarMedico($event)" [disabled]="buscando || salvando">
              <option [ngValue]="null">Todos</option>
              <option *ngFor="let m of medicos" [ngValue]="m.cdMedico">{{ m.nmMedico }}</option>
            </select>
          </div>
        </div>

        <ng-container *ngIf="ehExame">
          <div class="campo">
            <label for="tExame">Exame</label>
            <div class="exame-sel" *ngIf="exameEscolhido; else buscaExame">
              <div><b>{{ exameEscolhido.nome }}</b> <span class="sub2">{{ exameEscolhido.parceiros.length }} parceiro(s)</span></div>
              <button type="button" class="link" (click)="removerExame()" [disabled]="buscando || salvando">trocar</button>
            </div>
            <ng-template #buscaExame>
              <input
                id="tExame"
                type="search"
                autocomplete="off"
                placeholder="Digite o nome do exame (mín. 3 letras)"
                [ngModel]="termoExame"
                (ngModelChange)="digitarExame($event)"
              />
              <p class="dica" *ngIf="buscandoExame">Buscando exames...</p>
              <p class="dica" *ngIf="erroExame">{{ erroExame }}</p>
              <div class="lista-exames" *ngIf="examesEncontrados.length">
                <button type="button" *ngFor="let g of examesEncontrados" (click)="escolherExame(g)">
                  <span>{{ g.nome }} <span class="selo warn" *ngIf="g.semValor">sem valor</span></span>
                  <span class="sub2">{{ g.parceiros.length }} parceiro(s)</span>
                </button>
              </div>
              <p class="dica" *ngIf="!buscandoExame && termoExame.trim().length >= 3 && !examesEncontrados.length && !erroExame">Nenhum exame encontrado.</p>
            </ng-template>
          </div>
          <div class="grid2" *ngIf="exameEscolhido">
            <div class="campo">
              <label for="tMedEx">Médico</label>
              <select id="tMedEx" [ngModel]="cascata.cdMedico" (ngModelChange)="trocarMedicoExame($event)" [disabled]="buscando || salvando">
                <option [ngValue]="null">Todos</option>
                <option *ngFor="let m of cascata.medicos" [ngValue]="m.codigo">{{ m.descricao }}</option>
              </select>
            </div>
            <div class="campo">
              <label for="tUnEx">Unidade</label>
              <select id="tUnEx" [ngModel]="cascata.cdEstabelecimento" (ngModelChange)="trocarUnidadeExame($event)" [disabled]="buscando || salvando">
                <option [ngValue]="null">Todas as unidades</option>
                <option *ngFor="let u of cascata.unidades" [ngValue]="u.codigo">{{ u.descricao }}</option>
              </select>
            </div>
          </div>
        </ng-container>

        <div class="linha-busca">
          <button type="button" class="btn btn-secundario" [disabled]="!podeBuscar || salvando" (click)="buscarVagas()">
            <svg class="i sm" viewBox="0 0 24 24"><circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" /></svg>
            {{ buscando ? 'Buscando vagas (21 dias)...' : 'Buscar vagas' }}
          </button>
          <span class="dica" *ngIf="ehExame && !exameEscolhido">Escolha o exame para buscar.</span>
        </div>

        <div class="alerta bad" *ngIf="erroBusca" role="alert"><div>{{ erroBusca }}</div></div>
        <div class="alerta warn" *ngIf="buscou && semanasComFalha">
          <div>{{ semanasComFalha }} das 3 semanas não puderam ser consultadas; o resultado pode estar incompleto.</div>
        </div>

        <!-- Resultado -->
        <ng-container *ngIf="buscou">
          <div class="semanas-linha">
            <span class="rot">Vagas nos próximos 21 dias</span>
            <div class="semanas" role="tablist">
              <button
                type="button"
                role="tab"
                *ngFor="let j of janelas; let i = index"
                [class.ativo]="semana === i"
                [attr.aria-selected]="semana === i"
                (click)="escolherSemana(i)"
              >{{ dataCurta(j.dtInicio) }} a {{ dataCurta(j.dtFim) }} <small>{{ vagasNaSemana(i) }}</small></button>
            </div>
          </div>

          <div class="vazio-busca" *ngIf="!diasDaSemana.length">Nenhuma vaga nesta semana.</div>

          <!-- Individual: horários por dia e agenda -->
          <div class="vagas" *ngIf="!lote && diasDaSemana.length">
            <div class="vaga-dia" *ngFor="let d of diasDaSemana">
              <b>{{ rotuloDia(d.data) }}</b>
              <div class="vaga-ag" *ngFor="let a of d.agendas">
                <div class="ag">{{ a.nmMedico || a.dsAgenda }}<small>{{ a.dsEspecialidade }} · {{ a.nmEstabelecimento }}</small></div>
                <div class="horas">
                  <button
                    type="button"
                    class="h-chip"
                    *ngFor="let v of a.vagas; trackBy: trackVaga"
                    [class.sel]="destino?.id === v.id"
                    [class.res]="v.ieStatusAgenda === 'R'"
                    [title]="(v.ieStatusAgenda === 'R' ? 'Reservado · ' : '') + (v.dsAgenda || '') + ' (' + v.duracao + ' min)'"
                    [disabled]="salvando"
                    (click)="escolherDestino(v)"
                  >{{ v.hrInicio }}{{ v.ieStatusAgenda === 'R' ? ' R' : '' }}</button>
                </div>
              </div>
            </div>
          </div>

          <!-- Lote: dia, agenda de destino e o novo horário de cada paciente -->
          <ng-container *ngIf="lote && diasDaSemana.length">
            <div class="dias-lote">
              <button
                type="button"
                *ngFor="let d of diasDaSemana"
                [class.ativo]="diaLote === d.data"
                [disabled]="salvando"
                (click)="escolherDiaLote(d.data)"
              >{{ rotuloDia(d.data) }}</button>
            </div>
            <p class="dica" *ngIf="!diaLote">Escolha o dia de destino.</p>

            <div class="ag-cards" *ngIf="diaLote">
              <button
                type="button"
                class="ag-card"
                *ngFor="let a of agendasDoDiaLote"
                [class.sel]="agendaLote?.cdAgenda === a.cdAgenda"
                [disabled]="!suficiente(a) || salvando"
                [title]="suficiente(a) ? 'Transferir para esta agenda' : 'Vagas insuficientes'"
                (click)="escolherAgendaLote(a)"
              >
                <b>{{ a.nmMedico || a.dsAgenda }}</b>
                <span>{{ a.dsAgenda }} · {{ a.dsEspecialidade }}</span>
                <span>{{ a.nmEstabelecimento }}</span>
                <span class="selo" [class.ok]="suficiente(a)" [class.bad]="!suficiente(a)">{{ livres(a) }} livres · {{ origens.length }} necessárias</span>
                <span class="selo cinza" *ngIf="mesmaAgenda(a)">mesma agenda</span>
              </button>
            </div>

            <ng-container *ngIf="agendaLote">
              <div class="alerta warn" *ngFor="let t of trocasMedicoLote">
                <svg class="i sm" viewBox="0 0 24 24"><path d="M12 3 2 21h20z" /><path d="M12 10v5M12 18h.01" /></svg>
                <div><b>O médico vai mudar:</b> {{ t.de }} → <b>{{ t.para }}</b>{{ origens.length > 1 ? ' para ' + t.qt + ' paciente' + (t.qt > 1 ? 's' : '') : '' }}. O atendimento passará a ser aberto no médico novo.</div>
              </div>
              <div class="alerta ok" *ngIf="!trocasMedicoLote.length">
                <svg class="i sm" viewBox="0 0 24 24"><path d="m5 12 5 5 9-10" /></svg>
                <div>Mesmo titular: o médico é mantido.</div>
              </div>
              <div class="alerta warn" *ngIf="algumJaPassou">
                <svg class="i sm" viewBox="0 0 24 24"><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></svg>
                <div>Há horários livres que já passaram hoje nesta agenda: o lote ocupa os primeiros livres do dia, inclusive esses.</div>
              </div>
              <div class="mini-wrap">
                <table class="mini">
                  <thead><tr><th>Paciente</th><th>De</th><th>Para</th></tr></thead>
                  <tbody>
                    <tr *ngFor="let m of mapaLote" [class.travou]="m.origem === bloqueado">
                      <td>{{ m.origem.paciente.nmPaciente }}</td>
                      <td>{{ dataCurta(m.origem.dtAgenda) }} {{ m.origem.hrInicio }}</td>
                      <td>
                        <b>{{ dataCurta(m.destino?.dtDisponivel || '') }} {{ m.destino?.hrInicio }}</b> · {{ agendaLote.nmEstabelecimento }}
                        <span class="selo warn" *ngIf="jaPassou(m)">já passou</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </ng-container>
          </ng-container>
        </ng-container>

        <!-- Individual: médico, retorno e canal -->
        <ng-container *ngIf="!lote && destino && medicoDestino as md">
          <div class="alerta warn" *ngIf="md.trocou && md.nm">
            <svg class="i sm" viewBox="0 0 24 24"><path d="M12 3 2 21h20z" /><path d="M12 10v5M12 18h.01" /></svg>
            <div><b>O médico vai mudar:</b> {{ medicoAtual(o) || '-' }} → <b>{{ md.nm }}</b>. O atendimento deste horário passará a ser aberto no médico novo.</div>
          </div>
          <div class="alerta ok" *ngIf="!md.trocou">
            <svg class="i sm" viewBox="0 0 24 24"><path d="m5 12 5 5 9-10" /></svg>
            <div>O médico é mantido{{ md.nm ? ' (' + md.nm + ')' : '' }}.</div>
          </div>
          <div class="alerta" [class.bad]="!supervisor" [class.warn]="supervisor" *ngIf="avisoRetorno">
            <svg class="i sm" viewBox="0 0 24 24"><path d="M12 3 2 21h20z" /><path d="M12 10v5M12 18h.01" /></svg>
            <div>{{ avisoRetorno }}</div>
          </div>
          <div class="campo" [class.erro]="tentou && !cdCanal">
            <label for="tCanal">Canal de contato <span class="req">*</span></label>
            <select id="tCanal" [(ngModel)]="cdCanal" [disabled]="salvando">
              <option [ngValue]="null">Selecione...</option>
              <option *ngFor="let c of canais" [ngValue]="c.codigo">{{ c.descricao }}</option>
            </select>
            <p class="dica">Remarcar nasce de um contato novo, por isso o canal é perguntado de novo.</p>
          </div>
        </ng-container>
      </ng-container>

      <div class="alerta bad" *ngIf="erro" role="alert">
        <svg class="i sm" viewBox="0 0 24 24"><path d="M12 3 2 21h20z" /><path d="M12 10v5M12 18h.01" /></svg>
        <div>
          {{ erro }}
          <ng-container *ngIf="bloqueado"> Tire {{ bloqueado.hrInicio }} {{ bloqueado.paciente.nmPaciente }} do lote e envie de novo.</ng-container>
          <ng-container *ngIf="lote && !bloqueado"> Nada foi transferido.</ng-container>
        </div>
      </div>
    </div>

    <div class="modal-rod">
      <span class="msg" *ngIf="tentou && faltando">{{ faltando }}</span>
      <button type="button" class="btn btn-contorno" (click)="cancelar()" [disabled]="salvando">Voltar</button>
      <button
        type="button"
        class="btn btn-primario"
        *ngIf="!erroAbertura"
        [disabled]="salvando || (!lote && !destino) || (lote && !agendaLote)"
        (click)="confirmar()"
      >
        <svg class="i sm" viewBox="0 0 24 24"><path d="M7 7h13l-4-4M17 17H4l4 4" /></svg>
        {{ rotuloConfirmar }}
      </button>
    </div>
  </div>
</div>
